import React, { useEffect, useState } from 'react';

interface StarProps {
  id: number;
  style: React.CSSProperties;
}

const NUM_STARS = 40; // Number of stars, adjust for performance/density

const AnimatedBackground: React.FC = () => {
  const [stars, setStars] = useState<StarProps[]>([]);

  useEffect(() => {
    const generateStars = () => {
      const newStars: StarProps[] = [];
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      for (let i = 0; i < NUM_STARS; i++) {
        const size = Math.random() * 18 + 8; // Star size between 8px and 26px (slightly smaller max)
        const duration = Math.random() * 10 + 8; // Animation duration 8s to 18s (faster)
        const delay = Math.random() * duration; // Staggered start times, up to one full duration

        // Drift distance relative to star size, can be adjusted
        const driftX = (Math.random() - 0.5) * (viewportWidth / 4.5); // Drift up to ~22% of viewport width
        const driftY = (Math.random() - 0.5) * (viewportHeight / 4.5); // Drift up to ~22% of viewport height

        newStars.push({
          id: i,
          style: {
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            width: `${size}px`,
            height: `${size}px`,
            animationDuration: `${duration}s`,
            animationDelay: `-${delay}s`, // Negative delay starts animation partway through
            '--drift-x': `${driftX.toFixed(0)}px`,
            '--drift-y': `${driftY.toFixed(0)}px`,
          } as React.CSSProperties,
        });
      }
      setStars(newStars);
    };
    
    generateStars();
    window.addEventListener('resize', generateStars); // Regenerate on resize

    return () => {
      window.removeEventListener('resize', generateStars);
    };
  }, []);

  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {stars.map(star => (
        <svg
          key={star.id}
          className="bg-star"
          style={star.style}
          viewBox="0 0 20 20" // Consistent viewBox for the path
          fill="none"
          stroke="rgba(147, 197, 253, 0.35)" // Tailwind blue-300 @ 35% opacity (slightly less than before for density)
        >
          {/* Wireframe 4-point star path */}
          <path d="M10 1 L12.5 7.5 L19 10 L12.5 12.5 L10 19 L7.5 12.5 L1 10 L7.5 7.5 Z" />
        </svg>
      ))}
    </div>
  );
};

export default AnimatedBackground;